<template>
  <span>
    <b-navbar id="nav" class="nav-draggable" type="dark" toggleable="lg" variant="dark">
      <b-navbar-toggle id='button-list' target="nav-collapse" class="align-items-center ml-0"> </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class='all-menus nav-draggable'>
          <IniciarDropdownGDI v-if="user.onlineType == 'GDI'"></IniciarDropdownGDI>
          <IniciarDropdownPGDI v-if="user.onlineType == 'PGDI'"></IniciarDropdownPGDI>
          <PAPDropdown v-if="user.role == 'PGDI' && showPAP"></PAPDropdown>
          <PCPDropdown v-if="user.role == 'PGDI' && showPCP"></PCPDropdown>
          <PlanoSafraDropdown v-if="showPlanoSafraDropdown"></PlanoSafraDropdown>
          <MonitoramentoDropdown id="navbar-monitoring" v-if="showMonitoramentoDropdown"></MonitoramentoDropdown>
          <MetasOnlineDropdown v-if="showMetasOnlineDropdown"></MetasOnlineDropdown>
          <DashboardDropdown v-if="showDashboardDropdown"></DashboardDropdown>
          <OccurrenceDropdown v-if="showOccurrenceDropdown"></OccurrenceDropdown>
          <AnalyticsDropdown v-if="showAnalyticsDropdown"></AnalyticsDropdown>
          <IndicatorDropdown v-if="showIndicatorEditor"></IndicatorDropdown>
          <RTADropdown v-if="showRTA"></RTADropdown>
          <ReportDropdown v-if="showReportDropdown"></ReportDropdown>
          <UserDropdown class='user-dropdown'></UserDropdown>
          <div class="fullScreen" @click="toggleFullScreen">
            <img class="Item" src="@/assets/tela_monitor.png" alt="Liga/Desliga tela cheia" />
          </div>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </span>
</template>

<script>
import UserDropdown from "./UserDropdown";
import IniciarDropdownGDI from "./IniciarDropdownGDI";
import IniciarDropdownPGDI from "./IniciarDropdownPGDI";
import PlanoSafraDropdown from "./PlanoSafraDropdown";
import MonitoramentoDropdown from "./MonitoramentoDropdown";
import DashboardDropdown from "./DashboardDropdown";
import AnalyticsDropdown from "./AnalyticsDropdown";
import OccurrenceDropdown from "./OccurrenceDropdown.vue";
import MetasOnlineDropdown from "./MetasOnlineDropdown";
import PCPDropdown from "./PCPDropdown";
import PAPDropdown from "./PAPDropdown";
import IndicatorDropdown from "./IndicatorDropdown.vue";
import RTADropdown from "./RTADropdown.vue";
import ReportDropdown from "./ReportDropdown.vue"
import { mapState } from "vuex";
import { PapMixin } from "../flowchart/utils/papMixin"

export default {
  name: "Navbar",
  components: {
    UserDropdown,
    IniciarDropdownGDI,
    IniciarDropdownPGDI,
    PlanoSafraDropdown,
    MonitoramentoDropdown,
    MetasOnlineDropdown,
    PCPDropdown,
    DashboardDropdown,
    AnalyticsDropdown,
    OccurrenceDropdown,
    PAPDropdown,
    IndicatorDropdown,
    RTADropdown,
    ReportDropdown
  },

  props: {
    title: String
    //hideToggle: Boolean,
    //hideUserDropdown: Boolean
  },

  mixins: [PapMixin],

  computed: mapState(["user"]),
  // icon() {
  //   return this.$store.state.isMenuVisible ? "fa-angle-left" : "fa-angle-down";
  // },
  data() {
    return {
      showPlanoSafraDropdown: false,
      showMonitoramentoDropdown: false,
      showMetasOnlineDropdown: false,
      showDashboardDropdown: false,
      showOccurrenceDropdown: false,
      showAnalyticsDropdown: false,
      showPCP: true,
      showPAP: false,
      showIndicatorEditor: false,
      showRTA: false,
      showReportDropdown: false,
    }
  },
  watch: {},

  methods: {
    logout() {
      // localStorage.removeItem("userKey");
      // localStorage.removeItem("tk");
      this.$store.commit("setUser", null);
      this.$store.commit("setToken", null);
      this.$router.push({ name: "auth" });
    },
    checkMenuDropdown() {
      for (let key in this.user.Permissions) {
        let arr = []
        if (key.match(/planosdesafrabudget/)) {
          arr.push(this.user.Permissions[key])
          if (arr.length > 0) {
            this.showPCP = false;
          }
        }

        let indArr = [];
        if (key.match(/editordeindicadores/)) {
          indArr.push(this.user.Permissions[key])
          if (indArr.length > 0 && this.user.Permissions[key].allowed && this.user.Permissions[key].permission != '' && this.user.Permissions[key].allowed == true) {
            this.showIndicatorEditor = true;
          }
        }

        let rtaArr = [];
        if (key.match(/rtahabilitar/)) {
          rtaArr.push(this.user.Permissions[key])
          if (rtaArr.length > 0 && this.user.Permissions[key].allowed && this.user.Permissions[key].permission != '' && this.user.Permissions[key].allowed == true) {
            this.showRTA = true;
          }
        }

        let reportArr = [];
        if (key.match(/relatorioshabilitar/)) {
          reportArr.push(this.user.Permissions[key])
          if (reportArr.length > 0 && this.user.Permissions[key].allowed && this.user.Permissions[key].permission != '' && this.user.Permissions[key].allowed == true) {
            this.showReportDropdown = true;
          }
        }
      }

      for (let key in this.user.Permissions) {
        let arr = []
        if (key.match(/pap/) && this.user.Permissions[key].allowed && this.user.Permissions[key].permission != '') {
          arr.push(this.user.Permissions[key])
          if (arr.length > 0) {
            this.showPAP = true;
          }
        }
      }

      for (let key in this.user.Permissions) {
        let arr = []
        if (key.match(/\bmonitoramento\d+\b/) && this.user.Permissions[key].allowed && this.user.Permissions[key].permission != '') {
          arr.push(this.user.Permissions[key])
          if (arr.length > 0) {
            this.showMonitoramentoDropdown = true;
          }
        }
      }
      for (let key in this.user.Permissions) {
        let arr = []
        if (key.match(/dashboard/) && this.user.Permissions[key].allowed) {
          arr.push(this.user.Permissions[key])
          if (arr.length > 0) {
            this.showDashboardDropdown = true;
          }
        }
      }
      for (let key in this.user.Permissions) {
        let arr = []
        if (key.match(/metaonline/) && this.user.Permissions[key].allowed && this.user.Permissions[key].permission != '') {
          arr.push(this.user.Permissions[key])
          if (arr.length > 0) {
            this.showMetasOnlineDropdown = true;
          }
        }
      }
      for (let key in this.user.Permissions) {
        let arr = []
        if ((key.match(/gerenciarplanosafra/) || key.match(/gerenciarplanobudget/)) && this.user.Permissions[key].allowed && this.user.Permissions[key].permission != '') {
          arr.push(this.user.Permissions[key])
          if (arr.length > 0) {
            this.showPlanoSafraDropdown = true;
          }
        }
      }
      for (let key in this.user.Permissions) {
        let arr = []
        if ((key.match(/occurrencemonitoring/) || key === "ocorrencias") && this.user.Permissions[key].allowed) {
          arr.push(this.user.Permissions[key])
          if (arr.length > 0) {
            this.showOccurrenceDropdown = true;
          }
        }
      }
      for (let key in this.user.Permissions) {
        let arr = []
        if ((key.match(/analise/)) && this.user.Permissions[key].allowed && this.user.Permissions[key].permission != '') {
          arr.push(this.user.Permissions[key])
          if (arr.length > 0) {
            this.showAnalyticsDropdown = true;
          }
        }
      }
    },
    toggleFullScreen() {
      var doc = window.document;
      var docEl = doc.documentElement;

      var requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
      var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

      if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
        requestFullScreen.call(docEl);
      }
      else {
        cancelFullScreen.call(doc);
      }
    },
  },
  created() {
    this.checkMenuDropdown();
  }
};
</script>

<style>
:root {
  --width-dropdown: 310px;
}

#nav,
.all-menus {
  height: 45px;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-end;
  font-size: 0.85rem;
  align-items: center;
}

.button-pap {
  display: flex;
  align-items: center;
  min-width: 55px;
  height: 22px;
  cursor: pointer;
}

ul.nav.nav-toggled.pap {
  margin: 0;
}

.pap>span>label {
  margin: 0px;
  cursor: pointer;
}

.pap>span>svg {
  margin: 0px;
  font-size: 22px;
}

.pap {
  display: flex !important;
  justify-items: center;
  text-decoration: none;
  color: #FFFFFF80;
  margin-right: 30px;
}

.pap:hover {
  text-decoration: none;
  color: #FFFFFFBF;
}

ul.nav {
  align-items: center;
}

ul.nav>img {
  width: 27px;
  height: 27px;
}

.user-dropdown {
  width: 100%;
  justify-content: flex-end;
}

#button-list:hover {
  background-color: #fff1;
}

#button-list:active {
  border: 4px solid #fff5;
}

#button-list>span {
  width: 20px;
  height: 20px;
}


ul.nav,
.nav-item {
  padding: 0px 10px 0px 0px;
}

.nav-draggable .collapse.show {
  /* background-color: rgb(141, 141, 141); */
  background-color: #343a40;
  z-index: 1;
  position: absolute;
  left: 10px;
  top: 45px;
}

.fullScreen {
  position: relative;
  cursor: pointer;
}

img.Item {
  height: 25px;
  width: 25px;
}

.imgGDI {
  max-height: 37px;
  margin: auto;
}

@media only screen and (max-width: 990px) {

  /* INICIO GLOBAL */
  .toggled {
    min-width: var(--width-dropdown);
    height: auto;
    overflow-x: scroll;
  }

  .all-menus {
    height: inherit;
    padding-bottom: 10px;
  }

  .fullScreen {
    display: none;
  }

  #nav-collapse {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  .user-dropdown {
    width: 100%;
    justify-content: flex-end;
  }

  #button-list {
    display: flex;
    justify-content: center;
    padding: 0px;
    width: 35px;
    height: 30px;
    border: 2.5px solid #fff5;
    outline: none;
    transition-duration: .3s;
  }

  .nav>li::-webkit-scrollbar {
    display: none;
  }

  .nav>li>ul>li {
    width: 290px;
  }

  .nav>li>ul>li>a {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    white-space: pre-wrap;
  }

  .nav-item.nav-single-item,
  .nav>li,
  .dropdown {
    box-sizing: border-box;
    transition-duration: .5s;
  }

  .nav>li>a {
    margin-right: 0;
  }

  ul.nav.nav-toggled.pap:hover,
  .dropdown:hover,
  .nav-item.nav-single-item:hover {
    color: #fff;
    background: linear-gradient(to right, #fff3, #343a40);
    border-bottom: 2px solid #fff3;
  }

  .nav>li>a>span:hover {
    color: #fff;
  }

  ul.dropdown-menu.show {
    min-width: var(--width-dropdown);
    background-color: white;
  }

  ul.nav,
  .nav-item {
    justify-content: flex-start;
    padding: 0 0 0 10px;
  }

  .nav-item.nav-single-item {
    align-self: normal;
    margin: 0 0 0 10px;
  }

  /* INICIO INICIAR DROPDOWN */
  .toToggle2 {
    display: none;
  }

  ul.nav.nav-toggled.pap {
    margin-left: 20px;
    padding: 8px 0 8px 10px;
  }

  .drop-item {
    width: 450px;
    font-size: 13px;
  }

  .dropItem {
    width: 25px;
    height: 25px;
  }

  .dropItem {
    width: 25px;
    height: 25px;
  }

  .nav-toggled {
    width: 340px;
  }
}
</style>
